import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import type { Tables } from '@/integrations/supabase/types';

type PortfolioHealth = Tables<'portfolio_health'>;

export function useHealthAlerts(health: PortfolioHealth | null) {
  const firedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!health) return;
    const fired = firedRef.current;

    if (
      health.max_drawdown !== null &&
      Number(health.max_drawdown) > 0.03 &&
      !fired.has('drawdown')
    ) {
      fired.add('drawdown');
      toast.warning(
        `Drawdown alert: Portfolio down ${(Number(health.max_drawdown) * 100).toFixed(1)}% from peak`
      );
    }

    if (
      health.avg_correlation !== null &&
      Number(health.avg_correlation) > 0.7 &&
      !fired.has('correlation')
    ) {
      fired.add('correlation');
      toast.warning('Correlation risk: Your holdings are highly correlated');
    }

    if (
      health.idle_capital_pct !== null &&
      Number(health.idle_capital_pct) > 80 &&
      !fired.has('idle')
    ) {
      fired.add('idle');
      toast.info('80% of your capital is idle. Consider deploying a strategy.');
    }

    if (
      health.health_score !== null &&
      health.health_score < 50 &&
      !fired.has('critical')
    ) {
      fired.add('critical');
      toast.error('Portfolio health is critical. Review your positions.');
    }
  }, [health]);
}
